/* eslint camelcase: 0 */
import { RoomUnread } from '@/infrastructure/network/Monitaro/schema/models'
import { IRoomUnreadProps, EmptyRoomUnreadPropsFactory } from '@/entities/RoomUnread'

export const toRoomUnreadProps = (props: RoomUnread[] | null | undefined): IRoomUnreadProps[] => {
  if (!props) {
    return []
  }

  return props.map((item) => {
    const { room_id, count } = item

    return EmptyRoomUnreadPropsFactory({
      roomId: room_id,
      count
    })
  })
}
